import { useMutation } from '@tanstack/react-query';

import type { ActivityId, ColorTheme, UserLanguage } from '../user/types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { userSchema } from '../user/schemas';

type Payload = {
  colorCombo: ColorTheme;
  emailAddress: string;
  language: UserLanguage;
  /** LeadJourney click id, used server-side to attribute the registration to its campaign. */
  leadJourneyClickId: string | null;
  mainOccupation: boolean;
  otherActivityInformation: string;
  password: string;
  phoneNumber: string;
  primaryActivity: ActivityId;
  referralCode: string | null;
  secondaryActivities: ActivityId[];
  vatNumber: string;
};

export const useRegister = () => {
  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: user } = await fetchJson('/registration/create-user-account', {
        method: 'POST',
        schema: apiResourceSchema(userSchema),
        body,
      });

      return user;
    },
  });
};
